import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid} from 'views/components';
import {CardTable} from 'views/module';

import Card from './Card';

import backend from 'utils/backend';

const List = (props) => {
  const [data, setData] = React.useState([]);
  const [lastEvaluatedKey, setLastEvaluatedKey] = React.useState();
  const [stage, setStage] = React.useState('FILL');
  const requestIdRef = React.useRef(0);

  const progressWrap = props.statusProgressWrap;
  const selection = props.selection;
  const reload = props.reload;

  const isLoading = stage === 'LOADING';

  const loadData = async (reqId = requestIdRef.current, startKey = lastEvaluatedKey) => {
    setStage('LOADING');
    await progressWrap(async () => {
      const filter = [];

      for (const filterSelected of Object.values(selection.filter)) {
        if (!filterSelected.optionSelected || filterSelected.optionSelected === 'ALL') {
          continue;
        }
        const rawValue = filterSelected.optionSelected;
        const value = filterSelected.filterData.type === 'text' && typeof rawValue === 'string' ?
          rawValue.replace(/[^a-z0-9 ]/gi, '') : rawValue;
        filter.push(
            {
              key: filterSelected.filterData.key,
              value: value,
            },
        );
      }

      const sortBy = {
        sortKey: 'createdAt',
        sortDirection: 'DESC',
      };

      const result = await backend.client.queryClient(filter, sortBy, startKey);

      if (reqId !== requestIdRef.current) return;

      let filteredList = result.list;

      // Filter out ACTIVE and INACTIVE when status is ALL
      const statusFilter = Object.values(selection.filter).find((f) => f.filterData.key === 'status');
      if (statusFilter && (statusFilter.optionSelected === 'ALL' || !statusFilter.optionSelected)) {
        filteredList = filteredList.filter((item) => item.status !== 'ACTIVE' && item.status !== 'INACTIVE');
      }

      setData((e) => {
        return [
          ...e,
          ...filteredList,
        ];
      });
      setLastEvaluatedKey(result.lastEvaluatedKey);
    }, {showProgress: false});
    if (reqId === requestIdRef.current) {
      setStage('COMPLETE');
    }
  };

  React.useEffect(() => {
    requestIdRef.current += 1;
    setData([]);
    setLastEvaluatedKey(null);
    loadData(requestIdRef.current, null);
  }, [selection, reload]);


  return (
    <Grid container>
      <CardTable
        data={data}
        card={Card}
        isLoading={isLoading}
        loadMore={loadData}
        hasMore={!!lastEvaluatedKey}
        cardsPerRow={2}
      />
    </Grid>
  );
};
List.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
  selection: PropTypes.object.isRequired,
  reload: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(List));
